// extracted by mini-css-extract-plugin
export default {"wrapper":"DS-z","firstToReview":"ES-z","productCards":"FS-z","productCard":"GS-z","stars":"HS-z","hidden":"IS-z"};